import { DOAbnormalTableHeaderData } from './../pages/do-abnormal/interface/do-abnormal-table-header-data';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageResp } from 'src/app/core/models/page/page-response';
import { environment } from 'src/environments/environment';
import { DOAbnormalTableHeaderGetRequest } from '../pages/do-abnormal/interface/do-abnormal-table-header-get-request';
import { DOAbnormalTableDetailGetRequest } from '../pages/do-abnormal/interface/do-abnormal-table-detail-get-request';
import { DOAbnormalTableDetailData } from '../pages/do-abnormal/interface/do-abnormal-table-detail-data';
import { DOAbnormalTableAbnormalItemGetRequest } from '../pages/do-abnormal/interface/do-abnormal-table-abnormal-item-get-request';
import { DOAbnormalTableAbnormalItemData } from '../pages/do-abnormal/interface/do-abnormal-table-abnormal-item-data';
import { DOAbnormalTableAbnormalItemSaveRequest } from '../pages/do-abnormal/interface/do-abnormal-table-abnormal-item-save-request';
import { DOAbnormalMailRequest } from '../pages/do-abnormal/interface/do-abnormal-mail-request';
import { DOAbnormalCreateAbnormalItemRequest } from '../pages/do-abnormal/interface/do-abnormal-create-abnormal-item-request';
import { DOAbnormalItemFileResponse } from '../pages/do-abnormal/interface/do-abnormal-item-file-response';
import { DOAbnormalTableHeaderUpdateRequest } from '../pages/do-abnormal/interface/do-abnormal-table-header-update-request';
import { DOAbnormalDialogAbnormalItemFileUpdateRequest } from '../pages/do-abnormal/interface/do-abnormal-dialog-abnormal-item-file-update-request';
import { DOAbnormalDialogAbnormalItemFileUpdateResponse } from '../pages/do-abnormal/interface/do-abnormal-dialog-abnormal-item-file-update-response';
import { DOAbnormalItemFilesRequest } from '../pages/do-abnormal/interface/do-abnormal-item-file-request';

@Injectable({
  providedIn: 'root'
})
export class DoAbnormalService {

  private baseUrl: string = `${environment.logisticsApiUrl}/doAbnormal`;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  }

  constructor(
    private http: HttpClient
  ) { }

  findDoAbnormalHeader(headerTableGetRequest: DOAbnormalTableHeaderGetRequest): Observable<PageResp<DOAbnormalTableHeaderData>> {
    const url = this.baseUrl + '/findHeader';
    return this.http.post<PageResp<DOAbnormalTableHeaderData>>(url, headerTableGetRequest, this.httpOptions);
  }

  findDOAbnormalDetail(detailTableGetRequest: DOAbnormalTableDetailGetRequest): Observable<PageResp<DOAbnormalTableDetailData>> {
    const url = this.baseUrl + '/findDetail';
    return this.http.post<PageResp<DOAbnormalTableDetailData>>(url, detailTableGetRequest, this.httpOptions);
  }

  findDOAbnormalItem(abnormalItemTableGetRequest: DOAbnormalTableAbnormalItemGetRequest): Observable<PageResp<DOAbnormalTableAbnormalItemData>> {
    const url = this.baseUrl + '/findAbnormalItem';
    return this.http.post<PageResp<DOAbnormalTableAbnormalItemData>>(url, abnormalItemTableGetRequest, this.httpOptions);
  }

  findFilesBySnGroup(doAbnormalItemFileRequest: DOAbnormalItemFilesRequest): Observable<DOAbnormalItemFileResponse> {
    const url = this.baseUrl + '/findAbnormalItemFiles'
    return this.http.post<DOAbnormalItemFileResponse>(url, doAbnormalItemFileRequest, this.httpOptions);
  }

  updateHeader(updatedHeaderList: DOAbnormalTableHeaderUpdateRequest): Observable<void> {
    const url = this.baseUrl + '/updateHeader'
    return this.http.post<void>(url, updatedHeaderList, this.httpOptions);
  }

  createDOAbnormalItem(createDOAbnormalItemRequest: DOAbnormalCreateAbnormalItemRequest): Observable<void> {
    const url = this.baseUrl + '/createAbnormalItem';
    return this.http.post<void>(url, createDOAbnormalItemRequest, this.httpOptions);
  }

  saveAbnormalItemChanges(saveRequest: DOAbnormalTableAbnormalItemSaveRequest): Observable<void> {
    const url = this.baseUrl + '/saveAbnormalItemChanges'
    return this.http.post<void>(url, saveRequest, this.httpOptions);
  }

  updateAbnormalItemFile(updateRequest: DOAbnormalDialogAbnormalItemFileUpdateRequest): Observable<DOAbnormalDialogAbnormalItemFileUpdateResponse> {
    const url = this.baseUrl + '/updateAbnormalItemFiles'
    return this.http.post<DOAbnormalDialogAbnormalItemFileUpdateResponse>(url, updateRequest, this.httpOptions);
  }

  sendNotification(doAbnormalMailRequest: DOAbnormalMailRequest, lang: string): Observable<void> {
    const url = this.baseUrl + `/sendNotification/${lang}`;
    return this.http.post<void>(url, doAbnormalMailRequest, this.httpOptions);
  }

  replyNotification(doAbnormalMailRequest: DOAbnormalMailRequest, lang: string): Observable<void> {
    const url = this.baseUrl + `/replyNotification/${lang}`;
    return this.http.post<void>(url, doAbnormalMailRequest, this.httpOptions);
  }
}
